import { render, staticRenderFns } from "./RequisitionsMailboxes.vue?vue&type=template&id=1a887c1e&lang=pug&"
import script from "./RequisitionsMailboxes.vue?vue&type=script&lang=js&"
export * from "./RequisitionsMailboxes.vue?vue&type=script&lang=js&"
import style0 from "./RequisitionsMailboxes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports